<header class="sticky top-0 z-30 bg-white/95 backdrop-blur-md border-b border-gray-100">
  <!-- PC: max-w-[1200px] 컨테이너 -->
  <div class="max-w-[1200px] mx-auto flex items-center justify-between px-4 py-3 md:h-16">
    <!-- 로고 -->
    <div class="flex items-center gap-10">
      <a routerLink="/" class="flex items-center gap-2">
        <img src="/logo.svg" alt="Pig Bank" class="h-8 w-auto" />
      </a>

      <!-- PC 네비게이션 (md 이상) -->
      <nav class="hidden md:flex items-center gap-10">
        <a routerLink="/product" class="text-base font-semibold text-gray-600 hover:text-primary transition-colors">
          투자 상품
        </a>
        <a routerLink="/shop" class="text-base font-semibold text-gray-600 hover:text-primary transition-colors">
          흑돼지 쇼핑
        </a>
        <a
          routerLink="/customer/notice"
          class="text-base font-semibold text-gray-600 hover:text-primary transition-colors">
          고객지원
        </a>
      </nav>
    </div>

    <!-- 우측 액션 -->
    <div class="flex items-center gap-2">
      @if (userStore.user()) {
        <!-- 알림 -->
        <a
          routerLink="/my-page/notification-list"
          class="relative flex items-center justify-center size-10 rounded-full hover:bg-gray-100 transition-colors">
          @if (notificationStore.count() > 0) {
            <span class="icon-[material-symbols--notifications-active] text-primary text-2xl"></span>
            <span
              class="absolute -top-0.5 -right-0.5 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold text-white bg-red-500 rounded-full">
              {{ notificationStore.count() > 99 ? '99+' : notificationStore.count() }}
            </span>
          } @else {
            <span class="icon-[material-symbols--notifications-outline] text-gray-700 text-2xl"></span>
          }
        </a>
        <!-- 마이페이지 -->
        <a
          routerLink="/my-page"
          class="flex items-center justify-center size-10 rounded-full hover:bg-gray-100 transition-colors">
          <span class="icon-[material-symbols--account-circle] text-gray-700 text-2xl"></span>
        </a>
      } @else {
        <!-- 로그인 버튼 (비로그인 시) -->
        <!-- 모바일: 아이콘 -->
        <a
          routerLink="/sign-in"
          class="md:hidden flex items-center justify-center size-10 rounded-full hover:bg-gray-100 transition-colors">
          <span class="icon-[material-symbols--login] text-gray-700 text-2xl"></span>
        </a>
        <!-- PC: 텍스트 버튼 -->
        <a
          routerLink="/sign-in"
          class="hidden md:flex items-center gap-1 text-sm font-semibold text-gray-600 hover:text-primary transition-colors">
          <span class="icon-[material-symbols--login] text-lg"></span>
          로그인
        </a>
      }
    </div>
  </div>

  <!-- 모바일 네비게이션 바 (md 미만) -->
  <nav class="md:hidden flex items-center border-t border-gray-100 px-4">
    <a
      routerLink="/product"
      routerLinkActive="text-primary border-b-2 border-primary"
      [routerLinkActiveOptions]="{ exact: true }"
      class="flex-1 text-center py-2.5 text-sm font-semibold text-gray-500 transition-colors">
      투자 상품
    </a>
    <a
      routerLink="/shop"
      routerLinkActive="text-primary border-b-2 border-primary"
      [routerLinkActiveOptions]="{ exact: true }"
      class="flex-1 text-center py-2.5 text-sm font-semibold text-gray-500 transition-colors">
      흑돼지 쇼핑
    </a>
    <a
      routerLink="/customer/notice"
      routerLinkActive="text-primary border-b-2 border-primary"
      class="flex-1 text-center py-2.5 text-sm font-semibold text-gray-500 transition-colors">
      고객지원
    </a>
  </nav>
</header>
